import { render, staticRenderFns } from "./BookList.vue?vue&type=template&id=89ed3586&scoped=true&"
import script from "./BookList.vue?vue&type=script&lang=ts&"
export * from "./BookList.vue?vue&type=script&lang=ts&"
import style1 from "./BookList.vue?vue&type=style&index=1&id=89ed3586&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ed3586",
  null
  
)

export default component.exports